import Em from 'ember';

export default Em.Component.extend({
  actions: {
    clickedOk() {
      this.get('inserterApi.createBlock')('paragraph', {
        text: 'Inserty blocky',
        align: 'left',
      });
    },
  },
});
